
<div>
    <section>
        <div>
            <fuse-card class="mt-12 shadow-lg drop-shadow" *ngFor="let order of debitOrders" >
                <div class="flex flex-col w-full">
                    <div>
                        <h1 class="font-bold text-2xl px-4 pt-2">
                            {{order.LeadActionTypeCode == 'PreOrder' ? 'Pre-Order' : 'Order'}} {{order?.LeadNumber}}  
                        </h1>
                        <h1 class="text-2xl px-4 font-medium pb-2">
                             {{order?.Items[0]?.PackageDescription}}  
                        </h1>
                        <p *ngIf="order.upFrontAmount >= 1" class="font-medium mt-2 px-4 text-base">
                            Please complete the following "Final Steps" checklist. We cannot process your order until
                            all steps are complete.
                        </p>
                        <hr class="my-3 mb-0">
                    </div>
                    <div class="lg:mx-64 max-sm:scale-90 py-4 my-auto" >
                        <mat-stepper labelPosition="bottom" #stepper  [selectedIndex]="order?.DebitOrderMandateRequired && order?.debitOrderMandate?.Status != 'Accepted' ? 1 : 2">
                            <mat-step label="Order placed">
                            </mat-step>
                            <mat-step label="Final steps checklist">
                            </mat-step>
                            <mat-step label="Order processing">
                            </mat-step>
                        </mat-stepper>
                    </div>
                    <div *ngIf="!order.isFibre" class="p-4 w-full">
                        <h1 class="font-bold text-lg">
                            RICA Documentation
                        </h1>
                        <div *ngIf="uploadedProof && uploadedId">
                            <p class="text-base">
                                RICA documents have been uploaded, please review your documents to ensure your documents are still valid.
                            </p>
                            <button class="md:text-lg text-md font-bold bg-accent-500 text-black mt-4 w-full lg:w-1/3" mat-flat-button (click)="goToRica()">
                                View uploaded documents  
                            </button>
                        </div>
                        <div *ngIf="!uploadedProof && !uploadedId">
                            <p class="text-base">
                                Upload your RICA documents, which you can find in the ”Profile" section under “My account”. 
                            </p>
                            
                            <button class="md:text-lg text-md font-bold bg-accent-500 text-black mt-4 w-full lg:w-1/3" mat-flat-button (click)="goToRica()">
                                Upload documents  
                            </button>
                        </div>
                    </div>
                    <div class="px-4">
                        <app-debit-orders [orderFromDashboard]="order" (loadOrders)="loadOrders()"></app-debit-orders>
                    </div>
                    <div class="px-4" *ngIf="order.upFrontAmount >= 1">
                        <app-upfront-payment [checkoutProcessView]="false" [upFrontAmount]="order.upFrontAmount" [leadId]="order.LeadEntityID"></app-upfront-payment>
                    </div>

                    <div *ngIf="order.isFibre && order.upFrontAmount == 0 && (!order.DebitOrderMandateRequired || !order.debitOrderMandate)" class="flex justify-center items-center p-8">
                        <h1 class="text-xl text-justify">
                            We’ve received everything we need to process your order. Our team is now working on it, and we’ll keep you updated every step of the way
                        </h1>
                    </div>
                    <hr class="m-0 my-4">

                    <div class="p-4 flex flex-col items-start">
                        <h1 class="font-bold text-lg">
                            Installation Address
                        </h1>
                        <p class="font-medium">
                             {{order?.Address}}  
                        </p>
                        <div class="flex justify-end w-full">
                            <div *ngFor="let i of order.Items">
                                <button *ngIf="!actionsLoading && !i.UseSpecialProductService && i.IsCoreProduct" class="md:text-lg text-md font-bold bg-primary-600 text-white mt-4" mat-flat-button (click)="cancelOrder(order)">
                                    Cancel {{order.LeadActionTypeCode == 'PreOrder' ? 'Pre-Order' : 'Order'}}
                                </button>
                                <button *ngIf="!actionsLoading && i.UseSpecialProductService && i.IsCoreProduct" class="md:text-lg text-md font-bold bg-primary-600 text-white mt-4" mat-flat-button (click)="openSpecialProducts(order.LeadEntityID)">
                                    Special Product Options
                                </button>
                                <button *ngIf="!actionsLoading && !i.UseSpecialProductService && i.IsCoreProduct && order.LeadActionTypeCode == 'PreOrder'" class="md:text-lg text-md font-bold bg-accent ml-4 text-black mt-4" mat-flat-button (click)="completeOrder(order)">
                                    Complete Pre-Order
                                </button>
                                <button *ngIf="actionsLoading && !i.UseSpecialProductService && i.IsCoreProduct" class="md:text-lg text-md font-bold bg-primary-600 text-white mt-4" mat-flat-button>
                                    <mat-spinner class="h-5 w-5 white"></mat-spinner>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </fuse-card>
        </div>
    </section>
</div> 

<ng-template #specialProductsModal>

    <!-- Alert -->
    <fuse-alert
        class="mt-8 top-0 right-0 absolute z-99"
        *ngIf="showSpecialProdutsAlert"
        [appearance]="'outline'"
        [showIcon]="false"
        [type]="alert.type"
        [@shake]="alert.type === 'error'">
        {{alert.message}}
    </fuse-alert>


    <div *ngFor="let a of specialProductActions">
                        
        <div class="flex flex-row pb-2 text-black font-extrabold">
            {{a.ActionDescription}}
        </div>

        <div *ngIf="a.ClientSideExecutionType == 'Selection'">
            <mat-form-field class="w-full" *ngIf="!executeProductAction.ErrorMessage && !executeProductAction.SubAction">
                <mat-select matNativeControl (selectionChange)="specialProductSelection($event)">
                    <mat-option [placeholder]="a.ActionName" *ngFor="let a of executeProductAction.ClientSideInstructionData" [value]="a">{{a.display_text}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="w-full" *ngIf="!executeProductAction.ErrorMessage && executeProductAction.SubAction">
                <div *ngFor="let sa of executeProductAction.SubAction">
                    <div *ngIf="sa.ActionName == Confirm Cancellation">
                        <mat-select matNativeControl>
                            <input [placeholder]="sa.ParamName" [value]="sa.ParamValue" matInput>
                        </mat-select>
                    </div>

                </div>
                <mat-select matNativeControl (selectionChange)="specialProductSelection($event)">
                    <mat-option [placeholder]="a.ActionName" *ngFor="let a of executeProductAction.ClientSideInstructionData" [value]="a">{{a.display_text}}</mat-option>
                </mat-select>
            </mat-form-field>

            <div *ngIf="executeProductAction.ErrorMessage" class="text-red-500 p-4 justify-center items-center">
                {{executeProductAction.ErrorMessage}}
            </div>

            
            <div class="flex justify-end" *ngIf="!executeProductAction.ErrorMessage" >
                <button *ngIf="!subActionLoading" mat-flat-button class="bg-accent text-primary rounded-full py-2 px-4 ml-4" (click)="executeProductSubAction(a.ActionKey, a.SubActions[0].ActionKey, a.SubActions[0].InputParameters[0].ParamKey, a.SubActions[0].PreConfirmationText)">{{a.SubActions[0].ActionName}}</button>
                <button *ngIf="subActionLoading" mat-flat-button class="bg-accent text-primary rounded-full py-2 px-4 ml-4"><mat-spinner class="h-5 w-5 white"></mat-spinner></button>
            </div>
            <div class="flex justify-end" *ngIf="executeProductAction.ErrorMessage" >
                <button mat-flat-button class="bg-accent text-primary rounded-full py-2 px-4 ml-4" (click)="clearCart()">Cancel Order</button>
            </div>
        </div>
        <div *ngIf="a.ClientSideExecutionType == 'Render'">
            
            <div *ngIf="a.InputParameters">

                <form [formGroup]="addressActionForm" #addressActionNgForm="ngForm">
                    <div *ngFor="let ip of a.InputParameters; index as i">
    
                        <mat-form-field class="w-full" *ngIf="ip.UserSpecified">
                            <mat-label>{{ip.ParamName}}</mat-label>
                            <input [id]="ip.ParamKey" matInput [value]="ip.ParamValue" [required]="ip.Required" [formControlName]="ip.ParamKey">    
                        </mat-form-field>
                
                    </div>
                </form>
    
                <div class="flex justify-end">
                    <button *ngIf="!productActionLoading" [disabled]="!addressActionForm.valid" mat-flat-button class="bg-accent text-primary rounded-full py-2 px-4 ml-4" (click)="executeRenderProductAction(a.ActionKey)">{{a.ActionName}}</button>
                    <button *ngIf="productActionLoading" mat-flat-button class="bg-accent text-primary rounded-full py-2 px-4 ml-4"><mat-spinner class="h-5 w-5 white"></mat-spinner></button>
                </div>

            </div>

            <div *ngFor="let ec of renderProductAction.ClientSideInstructionData">
                <mat-form-field class="w-full" *ngIf="ec.RenderType == 'PlainText'">
                    <mat-label>{{ec.Description}}</mat-label>
                    <input matInput [value]="ec.Data" disabled>    
                </mat-form-field>

                <div class="flex justify-end" *ngIf="ec.RenderType == 'ActionLink'">
                    <button mat-flat-button class="bg-accent text-primary rounded-full py-2 px-4 ml-4" (click)="actionLinkAction(ec.Data)">{{ec.Description}}</button>
                </div>
            </div>
        </div>

    </div>

</ng-template>